module.exports = __webpack_public_path__ + "cv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cv.svg
// module id = 760
// module chunks = 0